import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.ProfileModule.ContactSalesPopup.hooks', {
    requestToSalesSuccessMessage: 'Your request has been submitted, our sales representative will contact you shortly.',
    requestToSalesFailedMessage: 'Oops... something went wrong',
});
